import styled from "styled-components";

export const StyledUserContainer = styled.section`
    color: black;
    width: 90%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    margin-top: 15px;
    align-items: center;
`

export const StyledProjectsContainer = styled.section`
  margin-bottom: 2rem;
  overflow-y: hidden;
  white-space: wrap;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  scrollbar-width: none;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 80%;
    > * {
        margin: 15px;
        width: 25%;
    }
`

